export interface PerformanceOptions {
  inferEveryNthFrame: number;
}

export class PerformanceController {
  private frameIndex = 0;

  constructor(private readonly opts: PerformanceOptions = { inferEveryNthFrame: 1 }) {}

  shouldInfer(): boolean {
    const should = this.frameIndex % this.opts.inferEveryNthFrame === 0;
    this.frameIndex += 1;
    return should;
  }

  setSkip(n: number): void {
    this.opts.inferEveryNthFrame = Math.max(1, Math.floor(n));
  }
}
